(function($) {
  'use strict';
  /*inicializamos scripts para que cargen en cuando finalice la carga del DOM */
  $(document).ready(function() {

    var offCanvas = $('#off-canvas');

    if (offCanvas.get(0)){

      var mmApi = $('#off-canvas').get(0).mmApi;

      /**
       * Activar o desactivar transparencia en el menú móvil según la altura de los elementos del menú
       */

      mmApi.bind('open:finish', setScrollable);

      mmApi.bind('openPanel:after', setScrollable);

      /**
       * Abrir siguiente panel de mmenujs
       */
      var url = window.location.pathname;
      $('#off-canvas a').each(function () {
        var href = $(this).attr("href");
        if (href == url) {
          var nextPanel = $(this).parent('li')[0].mmChild;
          if (nextPanel) {
            mmApi.openPanel(nextPanel);
          } else {
            mmApi.setSelected($(this).parent('li').get(0));
            mmApi.openPanel($('#off-canvas .mm-listitem_selected').get(0));
          }
          return false;
        }
      });

      /**
       * Bloquear Body al abrir menu
       */
      mmApi.bind('open:start', function() {
        document.body.classList.add('body--blocked');
        //document.querySelector('.hamburger').classList.add('is-active');
      });

      mmApi.bind('close:start', function() {
        document.body.classList.remove('body--blocked');
        //document.querySelector('.hamburger').classList.remove('is-active');
      });

      /**
         * Fix versión móvil para mostrar el modal de solicitud de información sobre el menú móvil
         */
      var infoButtonMobile = document.getElementById("requestInfoMobileButton");
      infoButtonMobile.addEventListener("click", function(){
        mmApi.close();
      });

      var closeButton = document.querySelector("#closeMenuMobileButton");
      if(closeButton){
        closeButton.addEventListener("click", function(){
          mmApi.close();
        });
      }

    }

  });

  function setScrollable(panel) {

    var mmPanels = document.querySelector('.mm-panels');

    if(!panel){
      mmPanels.classList.remove('scrollable');
      return;
    }

    var mmListview = panel.querySelector('.mm-listview');

    if (mmListview.offsetHeight + 64 > panel.offsetHeight - 100 ) {
      mmPanels.classList.add('scrollable');
    } else {
      mmPanels.classList.remove('scrollable');
    }
  }

})(jQuery)

